import 'jquery-ui-bundle';
import 'spectrum-colorpicker';
import '@loadingio/loading-bar';
import 'tui-image-editor';
import { axiosSaveImage } from '../../api/admin/common';

var uploadImage;
var getRatioThumbnail;
var uploadProgress;
var uploadComplete;
//for sample
var imgUrlSample =
    'https://cdn.rvtheme.com/templates/rvs_library/100/images/img-fashion-men-4.jpg';

window.rImageType = /data:(image\/.+);base64,/;
window.supportingFileAPI = !!(
    window.File &&
    window.FileList &&
    window.FileReader
);
window.$btnUndo = $('#btn-undo');
window.$btnRedo = $('#btn-redo');

window.$iconSubMenu = $('#icon-sub-menu');
window.$drawShapeSubMenu = $('#draw-shape-sub-menu');
window.$displayingSubMenu = $();
window.$textSubMenu = $('#text-sub-menu');
window.$imageFilterSubMenu = $('#image-filter-sub-menu');
window.$inputFontSizeRange = $('#input-font-size-range');
// Select shape type
window.$selectShapeType = $('[name="select-shape-type"]');
// Select color of shape type
window.$selectColorType = $('[name="select-color-type"]');

(function ($) {
    //make image instance
    window.imageEditor = new tui.ImageEditor('.tui-image-editor', {
        cssMaxWidth: 1000,
        cssMaxHeight: 800,
        selectionStyle: {
            cornerSize: 20,
            rotatingPointOffset: 70,
        },
    });

    window.resizeEditor = function () {
        var $editor = $('.tui-image-editor');
        var $container = $('.tui-image-editor-canvas-container');
        var height = parseFloat($container.css('max-height'));

        $editor.height(height);
    };

    window.applyOrRemoveFilter = function (applying, type, options) {
        if (applying) {
            imageEditor.applyFilter(type, options);
        } else {
            imageEditor.removeFilter(type);
        }
    };

    // Attach image editor custom events
    imageEditor.on({
        objectAdded: function (objectProps) {
            console.info(objectProps);
        },
        undoStackChanged: function (length) {
            if (length) {
                $btnUndo.removeClass('disabled');
            } else {
                $btnUndo.addClass('disabled');
            }

            resizeEditor();
        },
        redoStackChanged: function (length) {
            if (length) {
                $btnRedo.removeClass('disabled');
            } else {
                $btnRedo.addClass('disabled');
            }
            resizeEditor();
        },
        objectScaled: function (obj) {
            if (obj.type === 'text') {
                $inputFontSizeRange.val(obj.fontSize);
            }
        },
        addText: function (pos) {
            console.log(pos.originPosition);
            /*
             * imageEditor.addText('Double Click', { position: pos.originPosition
             * }).then(objectProps => { console.log(objectProps); });
             */
        },
        objectActivated: function (obj) {
            $('.textTools').hide();
            console.log(obj.type);
            console.log(obj);
            $('#cancelCrop').hide();

            window.activeObjectId = obj.id;
            if (
                obj.type === 'rect' ||
                obj.type === 'circle' ||
                obj.type === 'triangle'
            ) {
                showSubMenu('shape');
                setShapeToolbar(obj);
                activateShapeMode();
            } else if (obj.type == 'icon') {
                showSubMenu('icon');
                setIconToolbar(obj);
                activateIconMode();
            } else if (obj.type == 'i-text') {
                // alert(obj.type)

                showSubMenu('text');
                setTextToolbar(obj);

                activateTextMode();
                setTimeout(function () {
                    $('.textTools').show();
                }, 50);
            } else if (obj.type == 'cropzone') {
                $('#cancelCrop').show();
                $('.main-tool').css('visibility', 'hidden');
            }
        },
        mousedown: function (event, originPointer) {
            // console.log(originPointer.type)
            // imageEditor.stopDrawingMode();
            // imageEditor.startDrawingMode('TEXT');
            // $('.textTools').show();
            // console.log(imageEditor.getDrawingMode());
            // alert('')
            if (imageEditor.getDrawingMode() == 'TEXT') {
                $('.textTools').show();
                // imageEditor.stopDrawingMode()
            } else {
                $('.textTools').hide();
            }
            if (
                $imageFilterSubMenu.is(':visible') &&
                imageEditor.hasFilter('colorFilter')
            ) {
                imageEditor.applyFilter('colorFilter', {
                    x: parseInt(originPointer.x, 10),
                    y: parseInt(originPointer.y, 10),
                });
            }
        },
    });

    //for sample /admin/wysiwyg/uikit/imageeditor
    // imageEditor.loadImageFromURL(imgUrlSample, 'SampleImage').then(result => {
    //     console.log(result);
    //     imageEditor.clearUndoStack();
    // });

    // IE9 Unselectable
    $('.menu').on('selectstart', function () {
        return false;
    });

    var loadIng = false;

    console.log('window ', window);
    console.log('body', $('body'));

    $.when(
        $('#tabs').tabs({
            active: 2,
            activate: function (event, ui) {
                var imageAct = $('#tabs').tabs('option', 'active');
                //alert(active)
                var a = ['Crop', 'AddText', 'rotation', 'FilterColor'];

                imageE[a[imageAct]]();
            },
        })
    ).then(function () {
        $('#tabs').show();
    });

    $('#accordion').accordion({
        active: 2,
        collapsible: true,
        activate: function (event, ui) {
            //alert('ssss')
            var imageAct = $('#accordion').accordion('option', 'active');
            var a = ['Crop', 'AddText', 'rotation', 'FilterColor'];

            imageE[a[imageAct]]();
        },
    });

    $('.cfigUndoRedo').on('click', function () {
        // $displayingSubMenu.hide();
        cmd = $(this).attr('cmd');
        // if (!$(this).hasClass('disabled')) {
        imageEditor[cmd]();
        if (cmd == 'undo') {
            console.log(imageEditor.getDrawingMode());
            setTimeout(function () {
                if (imageEditor.getDrawingMode() == 'NORMAL') {
                    imageEditor.clearObjects();
                    //imageEditor.stopDrawingMode();
                }
            }, 50);
        }

        // }
    });

    imageE = {};
    imageE.Crop = function () {
        $('#cancelCrop').hide();
        imageEditor.startDrawingMode('CROPPER');
        $('.menuCrop').show();
    };
    imageE.AddText = function () {
        $('.menuCrop').hide();
        $('.main-tool').css('visibility', 'visible');

        imageEditor.stopDrawingMode();
        /*
           		var w = $('.upper-canvas ').width();
           		var h = $('.upper-canvas ').height();
           		$('.textTools').show();
       		 imageEditor.addText('  Text  ', {
                 position: {'x':w/2,'y':h/2}
             }).then(objectProps => {
                 console.log(objectProps);
             });
	             */
    };
    imageE.rotation = function () {
        imageEditor.stopDrawingMode();
        $('.menuCrop').hide();
        $('.main-tool').css('visibility', 'visible');
    };
    imageE.FilterColor = function () {
        imageEditor.stopDrawingMode();
        $('.menuCrop').hide();
        //alert('ss')

        imageEditor.stopDrawingMode();
    };

    $('.btnCrop').on('click', function () {
        imageEditor.startDrawingMode('CROPPER');
        $('.menuCrop').show();
        //$displayingSubMenu = $cropSubMenu.show();
    });

    $('#applyCrop').on('click', function () {
        imageEditor.crop(imageEditor.getCropzoneRect()).then(() => {
            imageEditor.stopDrawingMode();
            resizeEditor();
            imageEditor.startDrawingMode('CROPPER');
            $('#cancelCrop').hide();
            $('.main-tool').css('visibility', 'visible');
        });
        // $('.menuCrop').hide();
    });

    //reset image
    $('.cfigReset').on('click', function () {
        console.log('click cfigReset ', parent.fMimageURL);
        setTimeout(function () {
            parent.RVwys.loadImageFromURL(parent.fMimageURL);
            parent.RVwys.resetActiveImageEditorFull();
            //imageEditor.clearObjects();
        }, 300);
    });

    $('#cancelCrop').on('click', function () {
        //$('.menuCrop').hide();
        imageEditor.stopDrawingMode();
        imageEditor.startDrawingMode('CROPPER');
        $(this).hide();
        $('.main-tool').css('visibility', 'visible');
    });
    var aNull = { undefined: false, '': false, true: true };
    $('.configFilter').click(function () {
        $(this).toggleClass('active');
        var act = $(this).attr('act');
        var cmd = $(this).attr('cmd');
        var isAct = !aNull[act];
        $(this).attr('act', isAct);
        // alert(cmd)
        applyOrRemoveFilter(isAct, cmd, null);
    });

    /*
			 applyOrRemoveFilter(this.checked, 'brightness', {
        brightness: parseInt($inputRangeBrightnessValue.val(), 10)
    });
			*/
    $('.configFilter-range').bind('input', function () {
        //var act = $(this).attr('act');
        var cmd = $(this).attr('cmd');
        var mode = $(this).attr('mode');
        var val = $(this).val();
        var id = $(this).get(0).id;
        $('#' + id + '-value').html(val);
        var opt = {
            brightness: { brightness: parseInt(val, 10) },
            contrast: { contrast: parseInt(val, 10) },
        };
        applyOrRemoveFilter(true, cmd, opt[cmd]);
    });

    $('.configColor').click(function () {
        $(this).toggleClass('active');
        var act = $(this).attr('act');
        var cmd = $(this).attr('cmd');
        var mode = $(this).attr('mode');
        var cmdmain = $(this).attr('cmdmain');
        var opacity = $(this).attr('opacity');
        var aNull = { undefined: false, '': false, true: true };
        var isAct = !aNull[act];
        $(this).attr('act', isAct);

        var opt = {};
        if (cmd) {
            opt['color'] = cmd;
        }
        if (mode) {
            opt['mode'] = mode;
        }

        if (opacity) {
            opt['opacity'] = opacity;
        }
        console.log(opt);
        applyOrRemoveFilter(isAct, cmdmain, opt);
    });

    $('.configText').click(function () {
        var w = $('.upper-canvas ').width();
        var h = $('.upper-canvas ').height();
        $('.textTools').show();
        imageEditor
            .addText('  Text  ', {
                position: { x: w / 2, y: h / 2 },
            })
            .then(objectProps => {
                console.log(objectProps);
            });
    });

    $('#textSizeRange').on('input', function () {
        var id = $(this).get(0).id;
        $('#' + id + '-value').html($(this).val());

        imageEditor.changeTextStyle(activeObjectId, {
            fontSize: parseInt($(this).val(), 10),
        });
    });

    $('.textStyle').on('click', function (e) {
        // eslint-disable-line
        $(this).toggleClass('active');
        var act = $(this).attr('act');
        var cmd = $(this).attr('cmd');
        var opt = {};
        opt[act] = cmd;
        console.log(cmd);
        console.log(activeObjectId);
        e.stopPropagation();
        imageEditor.changeTextStyle(activeObjectId, opt);
    });

    $('#textColor').spectrum({
        flat: true,
        showInput: true,
        allowEmpty: true,
        showButtons: false,
        preferredFormat: 'hex',
        beforeShow: function () {},
        move: function (color) {
            imageEditor.changeTextStyle(activeObjectId, {
                fill: color,
            });
        },

        hide: function (color) {},
    });

    $('.configFlip').click(function () {
        var cmd = $(this).attr('cmd');
        imageEditor['flip' + cmd]().then(status => {
            console.log('flipX: ', status.flipX);
            console.log('flipY: ', status.flipY);
            console.log('angle: ', status.angle);
        });
    });
    $('.RotationRange').click(function () {
        // alert('ss')
        // alert($(this).val())
        var id = 'configRotation';
        $('#' + id + 'Range,#' + id + 'Number').val($(this).val());
        imageEditor.setAngle(parseInt($(this).val(), 10));
    });
    $('#configRotationNumber').bind('keyup change', function () {
        $('#configRotationRange').val($(this).val());
        imageEditor.setAngle(parseInt($(this).val(), 10)).catch(() => {});
    });
    $('#configRotationRange').bind('input', function () {
        var id = $(this).get(0).id;
        $('#' + id + '-value').html($(this).val());
        $('#configRotationNumber').val($(this).val());
        imageEditor.setAngle(parseInt($(this).val(), 10)).catch(() => {});
    });

    $('.cfigSave').click(function () {
        imageEditor.stopDrawingMode();
        imageEditor.startDrawingMode('CROPPER');
        imageEditor.stopDrawingMode();
        var imageName = imageEditor.getImageName();
        var dataURL = imageEditor.toDataURL();
        var blob, type, w;

        if (supportingFileAPI) {
            var blob = base64ToBlob(dataURL);
            var type = blob.type.split('/')[1];

            console.log(imageEditor);
            var width = $('.upper-canvas').attr('width');
            var height = $('.upper-canvas').attr('height');
            console.log(width + '-' + height);
            var imageNow = { width: width, height: height };
            // Library: FileSaver - saveAs
            var image = new Image();
            image.src = dataURL;
            image.onload = function () {
                var canvasThumb = document.createElement('canvas');
                var scale = 115;

                var ratio = getRatioThumbnail(this, scale);
                canvasThumb.width = this.width * ratio;
                canvasThumb.height = this.height * ratio;
                var ctxcanvasThumb = canvasThumb.getContext('2d');
                ctxcanvasThumb.drawImage(
                    this,
                    0,
                    0,
                    scale,
                    this.height * ratio
                );
                var thumbnail = canvasThumb.toDataURL('image/' + type);
                $(canvasThumb).remove();
                $('body').prepend(
                    $(
                        '<div class="overlaypanel"><div id="UL"class="ldBar label-center"data-value="0"data-preset="circle"></div></div>'
                    ).css({
                        width: $(document).width(),
                        height: $(document).height(),
                    })
                );
                loadIng = new ldBar($('#UL').get(0), {
                    stroke: '#FFF',
                });
                var sendImage = {
                    send: {
                        data: dataURL,
                        thumnail: thumbnail,
                        imageURL: imageEditor.rvsURL,
                        override: false,
                        imageName: imageName,
                        imageType: type,
                        tagFolder: '',
                    },
                };
                uploadImage(sendImage);
            };

            //saveAs(blob, imageName); // eslint-disable-line
        } else {
            alert('This browser needs a file-server');
            w = window.open();
            w.document.body.innerHTML = '<img src=' + dataURL + '>';
        }
    });

    // Convert xhr to axios axiosSaveImage
    function uploadImage(imgJSON) {
        console.log(
            'fn: imageEditor.uploadImage(imgJSON) File: imagesEditor/imageEditor.js'
        );
        console.log(imgJSON);

        axiosSaveImage(imgJSON.send)
            .then(response => {
                console.log('response ', response);
                //close overlaypanel
                console.log(
                    'axios close overlaypanel File: imageEditor/imageEditor.js'
                );

                var xhr = new XMLHttpRequest();

                xhr.upload.addEventListener(
                    'progress',
                    function (evt) {
                        uploadProgress(evt, imgJSON);
                    },
                    false
                );

                setTimeout(function () {
                    const evt = '';
                    uploadComplete(evt, imgJSON, response.data);
                }, 300);

                parent.console.pop.success({
                    text: 'Save Images Success',
                    delay: 5000,
                });
            })
            .catch(err => {
                parent.console.pop.error({
                    text: err.data.message,
                });
            });
    }

    function getRatioThumbnail(img, scale) {
        //alert('thumb-'+img)
        var ratio = 1;

        scale = scale ? scale : 115;
        if (img.width > scale) {
            ratio = scale / img.width;
        } else if (img.height > scale) {
            ratio = scale / img.height;
        }

        return ratio;
    }

    function base64ToBlob(data) {
        var mimeString = '';
        var raw, uInt8Array, i, rawLength;

        raw = data.replace(rImageType, function (header, imageType) {
            mimeString = imageType;

            return '';
        });

        raw = atob(raw);
        rawLength = raw.length;
        uInt8Array = new Uint8Array(rawLength); // eslint-disable-line

        for (i = 0; i < rawLength; i += 1) {
            uInt8Array[i] = raw.charCodeAt(i);
        }

        return new Blob([uInt8Array], { type: mimeString });
    }

    function setShapeToolbar(obj) {
        var strokeColor, fillColor, isTransparent;
        var colorType = $selectColorType.val();

        if (colorType === 'stroke') {
            strokeColor = obj.stroke;
            isTransparent = strokeColor === 'transparent';

            if (!isTransparent) {
                //  shapeColorpicker.setColor(strokeColor);
            }
        } else if (colorType === 'fill') {
            fillColor = obj.fill;
            isTransparent = fillColor === 'transparent';

            if (!isTransparent) {
                //  shapeColorpicker.setColor(fillColor);
            }
        }

        $inputCheckTransparent.prop('checked', isTransparent);
        $inputStrokeWidthRange.val(obj.strokeWidth);
    }

    function activateShapeMode() {
        if (imageEditor.getDrawingMode() !== 'SHAPE') {
            imageEditor.stopDrawingMode();
            imageEditor.startDrawingMode('SHAPE');
        }
    }

    function activateIconMode() {
        imageEditor.stopDrawingMode();
    }

    function activateTextMode() {
        if (imageEditor.getDrawingMode() !== 'TEXT') {
            imageEditor.stopDrawingMode();
            imageEditor.startDrawingMode('TEXT');
        }
    }

    function setTextToolbar(obj) {
        var fontSize = obj.fontSize;
        var fontColor = obj.fill;

        $inputFontSizeRange.val(fontSize);
        // textColorpicker.setColor(fontColor);
        $('#textSizeRange-val').html(Math.round(fontSize));
        $('#textSizeRange').val(fontSize);
        $('#textColor').spectrum('set', fontColor);
    }

    function setIconToolbar(obj) {
        var iconColor = obj.fill;

        // iconColorpicker.setColor(iconColor);
    }

    function showSubMenu(type) {
        var $submenu;

        switch (type) {
            case 'shape':
                $submenu = $drawShapeSubMenu;
                break;
            case 'icon':
                $submenu = $iconSubMenu;
                break;
            case 'text':
                $submenu = $textSubMenu;
                break;
            default:
                $submenu = 0;
        }

        $displayingSubMenu.hide();
        $displayingSubMenu = $submenu.show();
    }

    function uploadProgress(evt, imgJSON) {
        var percent = Math.round((evt.loaded * 100) / evt.total);
        //alert(percent)
        loadIng.set(percent - 1);
    }

    function uploadComplete(evt, imgJSON, responseData) {
        console.log('fn:uploadComplete responseData: ', responseData);
        var d = new Date();
        var n = d.getTime();

        var data = responseData;
        //var data = jQuery.parseJSON(responseData);
        //console.log('parseJSON data: ', data);
        if (parent.myimages) {
            Object.assign(parent.myimages, data.myimages);
        } else {
            parent.myimages = data.myimages;
        }
        if (parent.storeimages) {
            Object.assign(parent.storeimages, data.storeimages);
        } else {
            parent.storeimages = data.storeimages;
        }
        console.log(parent.myimages);

        var d = new Date();
        var n = d.getTime();
        parent.$('.myImageJSON').each(function () {
            var src = $(this)
                .attr('src')
                .replace(/\?n=\w*/gim, '');

            $(this).attr('src', src + '?n=' + n);
        });
        var imageItemHTML = parent.$('#designMyImageItem').html();
        var oImageItem = $(imageItemHTML);
        oImageItem
            .find('.insert')
            .attr({ data: data.src, imagekey: 'img_' + data.id });

        //alert(data.url)
        //alert(oImageItem.find('.insert').get(0).outerHTML)
        oImageItem
            .find('.remove')
            .attr({ imagename: data.name, imagekey: 'img_' + data.id });
        var attr = { src: data.thumnail_url, id: 'view_' + data.id };
        oImageItem.find('.imageItems').attr(attr);
        //alert('clear')
        //alert(oImageItem.html());
        //alert('clear2')

        if (parent.$('.imageBoxView-myimage').find('.workspace').html() != '') {
            oImageItem = parent.RVwys.imagemanager.eventMyImage(oImageItem);
            parent
                .$('.imageBoxView-myimage')
                .find('.workspace')
                .prepend(oImageItem);
            parent.RVwys.imagemanager.initImageDrag(oImageItem);
        }
        data.src = data.src + '?n=' + n + 'set';

        loadIng.set(100);
        setTimeout(function () {
            if (parent.insertToWys) {
                var fb = parent.$('#frameBody').get(0).contentWindow;
                fb.curImage.attr('src', data.src);
            }

            $('.overlaypanel').remove();
            parent.$('.overlaypanel').remove();

            $('.overlay-image').remove();
            parent.$('.overlay-image').remove();

            var options = {};
            options.title = 'Done!';
            options.type = 'success';
            options.text = '';
            options.hide = true;
            options.delay = 1200;
            options.buttons = {
                closer: true,
                sticker: true,
            };
            parent.console.pop.notice(options);
            parent.$('.wys-imageEditFull').hide();
        }, 500);
    }
})(jQuery);

window.uploadImage = uploadImage;
window.getRatioThumbnail = getRatioThumbnail;
window.uploadProgress = uploadProgress;
window.uploadComplete = uploadComplete;
//image editor
// window.activateShapeMode = activateShapeMode;
// window.activateIconMode = activateIconMode;
// window.activateTextMode = activateTextMode;
// window.setTextToolbar = setTextToolbar;
// window.setIconToolbar = setIconToolbar;
// window.setShapeToolbar = setShapeToolbar;
// window.showSubMenu = showSubMenu;
